export const environment = {
  name: 'production',
  production: true,
  baseUrl: `https://pay.kodypay.com`,
  baseDomainUrl: 'https://q.kpy.io',
  baseApiUrl: 'https://api.kodypay.com',
  checkoutAPIConf: {
    endpoint: 'https://api.checkout.com',
  },
  googlePayEnvironment: 'PRODUCTION',
  applePayMerchantId: 'merchant.com.kodypay.production',
  sentryDsn: 'https://66a0679e05124d9b9ce6480b91a65888@o1085662.ingest.sentry.io/6509091',
  launchDarklyClientId: '62d7e6d09077f110edff8e6a',
  tokiaSquareRestaurants: [],
  multiStoreMerchantIds: [],
};
